/**
 * Monitoring Event Data Formatter.
 * @param {*} value
 * @param {*} row
 * @returns {*}
 */
window.monitoringEventDataFormatter = function(value, row) {
    let html = '';
    switch (row.event) {
        case 'sms':
            html += row.data.phone;
            break;
        case 'email':
            html += row.data.email;
            break;
        default:
            break;
    }
    return html;
};
